__turbopack_context__.v({
  "active": "interactive-image-accordion-module__dZPeVq__active",
  "background": "interactive-image-accordion-module__dZPeVq__background",
  "chevron": "interactive-image-accordion-module__dZPeVq__chevron",
  "cigarIcon": "interactive-image-accordion-module__dZPeVq__cigarIcon",
  "content": "interactive-image-accordion-module__dZPeVq__content",
  "expanded": "interactive-image-accordion-module__dZPeVq__expanded",
  "heading": "interactive-image-accordion-module__dZPeVq__heading",
  "icon": "interactive-image-accordion-module__dZPeVq__icon",
  "item": "interactive-image-accordion-module__dZPeVq__item",
  "strip": "interactive-image-accordion-module__dZPeVq__strip",
  "title": "interactive-image-accordion-module__dZPeVq__title",
  "trigger": "interactive-image-accordion-module__dZPeVq__trigger",
  "withImage": "interactive-image-accordion-module__dZPeVq__withImage",
});
